var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[(_vm.bsc.addr)?_c('el-main',[_c('el-col',{attrs:{"id":"presale","lg":{ span: 12, offset: 6 },"md":{ span: 14, offset: 5 },"sm":{ span: 18, offset: 3 },"xs":{ span: 22, offset: 1 }}},[_c('PresaleMain')],1)],1):_c('el-col',{staticClass:"info"},[_c('h2',[_vm._v(_vm._s(_vm.$t("look-info")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }